export const promotionDetailTypesMap = {
  None: 'None',
  OnOrdersOver: 'OnOrdersOver',
  PromotionCode: 'PromotionCode',
};

export function getPromotionDetailTypeForModel(model) {
  let promotionDetailType;
  if (model.PromotionCode !== null) {
    promotionDetailType = promotionDetailTypesMap.PromotionCode;
  } else if (model.OrdersOverAmount !== null) {
    promotionDetailType = promotionDetailTypesMap.OnOrdersOver;
  } else {
    promotionDetailType = promotionDetailTypesMap.None;
  }

  return promotionDetailType;
}

export const isPromotionCode = promotionDetailType =>
  promotionDetailType === promotionDetailTypesMap.PromotionCode;

export const isOnOrdersOver = promotionDetailType =>
  promotionDetailType === promotionDetailTypesMap.OnOrdersOver;

export const cleanPromotionDetailTypeData = (promotionDetailType, model) => ({
  PromotionCode: isPromotionCode(promotionDetailType) ? model.PromotionCode : null,
  OrdersOverAmount: isOnOrdersOver(promotionDetailType) ? model.OrdersOverAmount : null,
});
